import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom"; // changed
import "./scss/style.scss";
import { ToastContainer, Flip } from "react-toastify";
import store from "./Redux/store";
import checkAuth from "./Authentication/Auth";
import * as ACTIONS from "./Redux/login/Action";
import { AUTHENTICATE_FAILED } from "./Redux/login/Types";
import "react-toastify/dist/ReactToastify.css";
import "./config/axiosConfig";
import "antd/dist/antd.css";
import ResetPassword from "./views/pages/ResetPassword";

const TheLayout = React.lazy(() => import("./containers/TheLayout"));
const Login = React.lazy(() => import("./views/pages/Login"));
const ForgotPassword = React.lazy(() => import("./views/pages/ForgotPassword"));
const Page404 = React.lazy(() => import("./views/pages/Page404"));
const PrivacyPolicy = React.lazy(() => import("./views/pages/PrivacyPolicy"));

const token = JSON.parse(localStorage.getItem("authToken"));
const loggedInUser = JSON.parse(localStorage.getItem("user"));

if (token && loggedInUser) {
  store.dispatch(ACTIONS.authenticate(loggedInUser));
} else {
  store.dispatch({ type: AUTHENTICATE_FAILED });
}

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

class App extends Component {
  render() {
    return (
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        {" "}
        {/* updated */}
        <ToastContainer
          transition={Flip}
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <React.Suspense fallback={loading}>
          <Switch>
            <Route
              exact
              path="/login"
              render={(props) => <Login {...props} />}
            />
            <Route
              exact
              path="/forgotpassword"
              render={(props) => <ForgotPassword {...props} />}
            />
            <Route
              exact
              path="/resetpassword/:type/:token"
              render={(props) => <ResetPassword {...props} />}
            />
            <Route
              exact
              path="/404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/privacy-policy"
              render={(props) => <PrivacyPolicy {...props} />}
            />
            <Route path="/" component={checkAuth(TheLayout)} />
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
